import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBasket2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBasket2"><Path d="M8.24826 3.75L6.24826 8.75H17.7483L15.7483 3.75M20.9427 10.507L19.6806 17.764C19.4307 19.201 18.1835 20.25 16.725 20.25H7.27156C5.81302 20.25 4.56583 19.201 4.31592 17.764L3.05383 10.507C2.89428 9.58959 3.60046 8.75 4.53165 8.75H19.4649C20.3961 8.75 21.1022 9.58959 20.9427 10.507Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBasket2;
